import React from 'react';
import TermsTemplate from './TermsTemplate';

export default function ServiceTerms() {
  const content = `
    <h2>제1조 (목적)</h2>
    <p>본 약관은 share2dm(이하 "서비스")의 이용과 관련하여 서비스 운영자(이하 "회사")와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>

    <h2>제2조 (용어의 정의)</h2>
    <ol>
      <li>"서비스"란 회사가 제공하는 Instagram 릴스 공유 기반 자동 DM 발송 마케팅 서비스를 의미합니다.</li>
      <li>"이용자"란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 자를 말합니다.</li>
      <li>"브랜드"란 서비스에 Instagram 비즈니스 계정을 연동하여 캠페인을 운영하는 이용자를 말합니다.</li>
      <li>"캠페인"이란 브랜드가 설정한 릴스와 자동 응답 메시지의 조합을 의미합니다.</li>
      <li>"공유자"란 브랜드의 Instagram 계정으로 릴스를 DM으로 공유하는 Instagram 사용자를 말합니다.</li>
      <li>"크리에이터"란 서비스에 가입하여 Clozet 크리에이터 네트워크에 포함된 이용자를 말합니다.</li>
    </ol>

    <h2>제3조 (약관의 효력 및 변경)</h2>
    <ol>
      <li>본 약관은 서비스 화면(https://share2dm.xyz/terms/service)에 게시함으로써 효력이 발생합니다.</li>
      <li>회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있습니다.</li>
      <li>회사가 약관을 변경할 경우 적용일자 및 변경사유를 명시하여 서비스 내에 그 적용일자 7일 전부터 공지합니다.</li>
    </ol>

    <h2>제4조 (서비스의 제공)</h2>
    <p>회사는 다음과 같은 서비스를 제공합니다.</p>
    <ul>
      <li>가. Instagram 비즈니스 계정 연동 (Facebook OAuth 기반)</li>
      <li>나. 릴스 기반 자동 DM 응답 캠페인 생성 및 관리</li>
      <li>다. 릴스 공유 감지 및 자동 DM 발송</li>
      <li>라. 캠페인별 공유 및 클릭 통계 제공</li>
      <li>마. 기타 회사가 추가 개발하여 제공하는 서비스</li>
    </ul>

    <h2>제5조 (크리에이터 네트워크)</h2>
    <ol>
      <li>서비스에 가입한 이용자는 Clozet 크리에이터 네트워크에 자동으로 포함됩니다.</li>
      <li>회사는 네트워크에 포함된 크리에이터에게 브랜드 협업 캠페인을 제안할 수 있습니다.</li>
      <li>캠페인 참여 여부는 크리에이터가 자유롭게 선택할 수 있으며, 참여 의무는 없습니다.</li>
      <li>크리에이터 네트워크 제외를 원하는 경우 서비스 탈퇴를 통해 처리됩니다.</li>
    </ol>

    <h2>제6조 (서비스 이용 조건)</h2>
    <ol>
      <li>서비스를 이용하기 위해서는 Instagram 비즈니스 계정과 이에 연결된 Facebook 페이지가 필요합니다.</li>
      <li>이용자는 Meta(Facebook/Instagram) 플랫폼 정책을 준수해야 합니다.</li>
      <li>이용자는 서비스 연동 시 요청되는 Instagram/Facebook 권한에 동의해야 합니다.</li>
    </ol>

    <h2>제7조 (서비스의 중단)</h2>
    <ol>
      <li>회사는 시스템 점검, 장비 교체, 장애 발생, Meta API 변경 등의 사유로 서비스 제공을 일시적으로 중단할 수 있습니다.</li>
      <li>회사는 서비스 중단 시 가능한 한 사전에 이를 공지합니다.</li>
      <li>Meta 플랫폼의 정책 변경 또는 API 제한으로 인한 서비스 중단에 대해서는 회사의 책임이 제한됩니다.</li>
    </ol>

    <h2>제8조 (이용자의 의무)</h2>
    <p>이용자는 다음 행위를 하여서는 안 됩니다.</p>
    <ul>
      <li>가. 스팸 또는 불법적인 내용의 자동 DM 발송</li>
      <li>나. Meta 플랫폼 정책에 위반되는 방식으로 서비스를 이용하는 행위</li>
      <li>다. 타인의 Instagram 계정을 도용하여 서비스에 연동하는 행위</li>
      <li>라. 서비스의 정상적인 운영을 방해하는 행위</li>
      <li>마. 서비스를 이용하여 법령에 위반되는 행위</li>
    </ul>

    <h2>제9조 (계정 해지 및 이용 제한)</h2>
    <ol>
      <li>이용자는 언제든지 서비스 이용을 중단하고 연동을 해제할 수 있습니다.</li>
      <li>회사는 이용자가 제7조의 의무를 위반한 경우 서비스 이용을 제한하거나 계정을 삭제할 수 있습니다.</li>
    </ol>

    <h2>제10조 (면책조항)</h2>
    <ol>
      <li>회사는 천재지변, 불가항력, Meta 플랫폼 장애 등으로 인하여 서비스를 제공할 수 없는 경우에는 책임이 면제됩니다.</li>
      <li>회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.</li>
      <li>회사는 이용자가 서비스를 통해 기대하는 마케팅 성과에 대하여 보장하지 않습니다.</li>
      <li>Meta API 정책 변경, Instagram 계정 제한 등 외부 요인으로 인한 서비스 제한에 대해서는 책임을 지지 않습니다.</li>
    </ol>

    <h2>제11조 (개인정보보호)</h2>
    <p>회사는 이용자의 개인정보를 보호하기 위하여 개인정보처리방침(https://share2dm.xyz/terms/privacy)을 수립하고 이를 준수합니다.</p>

    <h2>제12조 (분쟁해결)</h2>
    <ol>
      <li>회사와 이용자 간에 발생한 분쟁에 관한 소송은 대한민국 법원을 관할 법원으로 합니다.</li>
      <li>회사와 이용자 간에 제기된 소송에는 대한민국법을 적용합니다.</li>
    </ol>

    <p><strong>부칙</strong><br>
    본 약관은 2026년 4월 7일부터 시행됩니다. (구 약관: 2025년 2월 11일)</p>

    <p><strong>서비스 정보</strong><br>
    서비스명: share2dm<br>
    웹사이트: https://share2dm.xyz<br>
    이메일: jaewon@share2dm.xyz</p>
  `;

  return (
    <TermsTemplate
      title="서비스 이용약관"
      content={content}
      lastUpdated="2026년 4월 7일"
    />
  );
}
